import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import { Container } from 'reactstrap';
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import AppointmentFlowFooter from 'components/molecules/AppointmentFlowFooter/';
import AppointmentFlowHeader from 'components/molecules/AppointmentFlowHeader/';
import ServicesList from 'components/molecules/ServicesList';
import LoaderHOC from 'components/atoms/LoaderHOC';
import CTAFlowHeader from 'components/molecules/CTAFlowHeader';

// Utils
import { SERVICES_ROUTE, TRANSPORTATION_ROUTE } from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';

import './RecallPage.scss';
import { resetScrollPosition } from 'utils/DOM';

const ns = 'recall-page';
const { BACKWARD, FORWARD } = NAVIGATION;

class RecallPage extends Component {
  componentDidMount() {
    resetScrollPosition(0);
  }

  serviceListComponent = (recallServices, noRemedyServices) => {
    const { intl } = this.props;
    return (
      <div id="individual_services_section">
        <div>
          <ServicesList
            showSelectAll={Boolean(recallServices.length)}
            serviceList={recallServices}
            group={'recallGroup'}
          />
        </div>
        <div>
          {Boolean(noRemedyServices.length) && (
            <div className={`${ns}__label`}>
              {intl.formatMessage({
                id: 'c8.recall.page.label.no.fix.yet'
              })}
            </div>
          )}
          <ServicesList
            serviceList={noRemedyServices}
            group={'noRemedyGroup'}
          />
        </div>
        {Boolean(noRemedyServices.length) && (
          <div className={`${ns}__message`}>
            {intl.formatMessage({
              id: 'c8.recall.page.label.no.fix.provided.for.this.recall'
            })}
          </div>
        )}
      </div>
    );
  };

  throwGtmRecallsNotNeeded = (option, section) => {
    const { gtmUserEvent } = this.props;
    const button = section === 'Footer' ? 'Next' : 'Back';
    gtmUserEvent(
      'Recall Services Page',
      'Skipped',
      'Recall Services not used',
      `GTM_CURRENT_PAGE > ${option} Button`
    );
    gtmUserEvent(
      `On ${button} Button`,
      'Navigation',
      `Go ${button}`,
      `GTM_CURRENT_PAGE > ${section}`
    );
  };

  render() {
    const {
      className,
      recallServices,
      vehicle,
      goTo,
      recallsSelected,
      intl,
      ctaBanner,
      hideBottomCTA
    } = this.props;
    const { make, year, model } = vehicle;
    const classProps = cn(ns, className);
    const hasRecallsSelected = recallsSelected.length > 0;
    const recalls = recallServices.filter(
      recall => recall.status !== 'NO REMEDY'
    );
    const noRemedy = recallServices.filter(
      recall => recall.status === 'NO REMEDY'
    );
    const label = intl.formatMessage({
      id: 'c8.header.services'
    });
    const backButtonAriaLabel = intl.formatMessage({
      id: 'c8.aria.back.to.service.options',
      defaultMessage: 'Back to service options button'
    });
    const nextButtonAriaLabel = hasRecallsSelected
      ? intl.formatMessage({
          id: 'c8.aria.continue.setting.up.your.appointment',
          defaultMessage: 'Continue setting up your appointment'
        })
      : backButtonAriaLabel;

    return (
      <AppointmentFlowWizard
        className={classProps}
        header={() => {
          return ctaBanner !== null ? (
            <CTAFlowHeader
              label={label}
              hideServices={false}
              routeTo={SERVICES_ROUTE}
              backButtonAriaLabel={backButtonAriaLabel}
              nextButtonAriaLabel={nextButtonAriaLabel}
              ctaButtonDisabled={false}
              ctaBanner={ctaBanner}
              onClick={() => {
                if (!hasRecallsSelected)
                  this.throwGtmRecallsNotNeeded('BACK', 'Header');
              }}
              onClickCtaButton={() => {
                if (hasRecallsSelected) {
                  goTo(TRANSPORTATION_ROUTE, FORWARD);
                } else {
                  this.throwGtmRecallsNotNeeded('NOT NOW', 'Footer');
                  goTo(SERVICES_ROUTE, BACKWARD);
                }
              }}
              typeButton={'cta-next'}
              isBookItButtonVisible={false}
              labelCtaButton={intl.formatMessage({
                id: hasRecallsSelected ? 'c8.footer.next' : 'c8.footer.not.now'
              })}
            />
          ) : (
            <AppointmentFlowHeader
              label={label}
              onClick={() => {
                if (!hasRecallsSelected)
                  this.throwGtmRecallsNotNeeded('BACK', 'Header');
              }}
              routeTo={SERVICES_ROUTE}
              backButtonAriaLabel={backButtonAriaLabel}
            />
          );
        }}
        footer={() => {
          return !hideBottomCTA ? (
            <AppointmentFlowFooter
              buttonDisabled={false}
              buttonText={intl.formatMessage({
                id: hasRecallsSelected ? 'c8.footer.next' : 'c8.footer.not.now'
              })}
              onClick={() => {
                if (hasRecallsSelected) {
                  goTo(TRANSPORTATION_ROUTE, FORWARD);
                } else {
                  this.throwGtmRecallsNotNeeded('NOT NOW', 'Footer');
                  goTo(SERVICES_ROUTE, BACKWARD);
                }
              }}
            />
          ) : null;
        }}
        body={() => (
          <Container>
            <h1 className={`${ns}__title`}>
              {intl.formatMessage(
                { id: 'c8.recall.page.title' },
                { year, make, model }
              )}
            </h1>

            <LoaderHOC
              serviceId={'recall'}
              placeHolderType={() => {}}
              component={() => this.serviceListComponent(recalls, noRemedy)}
            />
          </Container>
        )}
      />
    );
  }
}

RecallPage.propTypes = {
  className: PropTypes.string,
  goTo: PropTypes.func.isRequired,
  gtmUserEvent: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  recallServices: PropTypes.array.isRequired,
  recallsSelected: PropTypes.array.isRequired,
  vehicle: PropTypes.object.isRequired,
  ctaBanner: PropTypes.object,
  hideBottomCTA: PropTypes.bool
};

export default RecallPage;



// WEBPACK FOOTER //
// ./src/components/pages/RecallPage/RecallPage.js